import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizationService } from 'src/app/core/helpers/localization.service';
import { TranslateService } from '@ngx-translate/core';
import { Loyaltic } from 'src/app/core/helpers/api-url.constants';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { GaService } from 'src/app/core/helpers/ga.service';

@Component({
  selector: 'loyaltic-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit, OnDestroy {
  culture = '';
  isLoggedIn = false;
  userId = '';
  popupKeysObj:any;
  showGenericPopup = false;
  hasGames = true;
  firstName = '';

  private fragment:string;

  externalUrl = Loyaltic.WithOutReceiptRedirectUrl;
  constructor(@Inject(DOCUMENT) private document: Document,
    private router: Router, private route: ActivatedRoute,
    private localizationService: LocalizationService,
    private translate: TranslateService,
    private authService: AuthService,
    private coreService: CoreService,
    private gaService: GaService) {
    this.culture = translate.getDefaultLang();
    this.isLoggedIn = authService.IsLoggedIn()

  }

  ngOnInit() {
    this.document.body.classList.add('landing');

    if (this.isLoggedIn){
      this.userId = this.authService.getUserId()
      this.firstName = localStorage.getItem("firstName")    
    }

    this.route.fragment.subscribe( fragment => {
      this.fragment=fragment; // get the fragment uploadDiv
    })

    this.authService.loginEmitter.subscribe((response: boolean) => {
      console.table(response);
     
    });
  }

  ngOnDestroy(): void {
    this.document.body.classList.remove('landing');
    this.localizationService.currentPage = '';
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: "smooth" });
  }

  freshParticipation() {
    this.authService.resetTokens();
    this.router.navigate(['']);
 }

 onLogoutClick() {
  this.isLoggedIn = false;
  this.authService.resetTokens();
  this.router.navigate(['']);
}

  goToRegistration = () => {
    this.router.navigate(['/register']);
  }
  goToUpload = () => {
    this.router.navigate(['/upload']);
  }
  // scroll to upload div after successful logged in
  ngAfterViewInit(): void {
    try {
      document.querySelector('#' + this.fragment).scrollIntoView();
    } catch (e) {}
  }

  facebookShare() {
    //api call
    const body = {
      // userid: this.userId
    }
    this.coreService.getfbBonuspoint(body, this.userId).then((response: any) => {
    });
    this.gaService.emitEvent('fb_share', 'fb_share');
    //console.log('calling fbshare()', window.location)
    let origin = window.location.origin
    window.open("https://www.facebook.com/dialog/share?app_id=356593812659402&display=popup&href=" + origin + "/&redirect_uri=" + origin + "/?status=fbsharewithpoints")
  }
}
